// Care level color mapping utility using the custom color palette
export const getCareColor = (careLevel: string | string[]): string => {
  if (Array.isArray(careLevel)) {
    // If multiple care levels, use gray color
    return careLevel.length > 1 ? '#797979' : getCareColor(careLevel[0]);
  }
  
  const colors: { [key: string]: string } = {
    'il': '#007271',    // Independent Living - Primary
    'al': '#203e7b',    // Assisted Living - Info
    'mc': '#e08215',    // Memory Care - Warning
    'snf': '#bf4f4f',   // Skilled Nursing - Danger
    'ccrc': '#e83e8c',  // CCRC - Pink
  };
  const careLevelStr = careLevel && typeof careLevel === 'string' ? careLevel.toLowerCase() : '';
  return colors[careLevelStr] || '#797979'; // Secondary for default
};

// Export the color mapping object for direct access if needed
export const careColors = {
  il: '#007271',    // Independent Living - Primary
  al: '#203e7b',    // Assisted Living - Info
  mc: '#e08215',    // Memory Care - Warning
  snf: '#bf4f4f',   // Skilled Nursing - Danger
  ccrc: '#e83e8c',  // CCRC - Pink
  default: '#797979' // Secondary for default
} as const;

// Custom color palette constants
export const colorPalette = {
  primary: '#007271',
  secondary: '#797979',
  success: '#007271',
  info: '#203e7b',
  warning: '#e08215',
  danger: '#bf4f4f',
  pink: '#e83e8c',
  light: '#e9ecef',
  dark: '#343a40'
} as const;

// Font family constant
export const fontFamily = '"Roboto", "Poppins", sans-serif';

// Type for care level keys
export type CareLevel = keyof typeof careColors;
